// Make/model/year options for the wizard's vehicle step.
//
// The step used to be three free-text boxes, which meant "Cheverolet",
// "chevy" and "Chevrolet" all reached the estimate engine as different
// vehicles - and the engine matches makes by string (vehicleClassOf in
// functions/estimate/engine.ts), so a typo silently downgraded a luxury or
// EV car to the mainstream cost factor. Picking from a list removes that
// whole class of error before it can happen.
import data from "../data/vehicles.json";

// Nobody gets stuck on a car we forgot: both lists carry an escape hatch.
// Stored as a plain "Other" so it reads sanely in the report line and in the
// session record - the longer wording is display only.
export const OTHER = "Other";
export const OTHER_LABEL = "Other / not listed";

export const MAKES: string[] = data.makes.map((m) => m.name);

export function modelsFor(make: string): string[] {
  return data.makes.find((m) => m.name === make)?.models ?? [];
}

export const YEARS: string[] = (() => {
  // Next model year is on sale before the calendar year turns over.
  const newest = new Date().getFullYear() + 1;
  const out: string[] = [];
  for (let y = newest; y >= data.minYear; y--) out.push(String(y));
  return out;
})();

// A session saved before these dropdowns existed (or one restored after the
// lists change) can hold a value the list no longer offers. Keep it as an
// option so hydrating a session never silently blanks the answer.
export function withCurrent(options: string[], current: string): string[] {
  if (!current || current === OTHER || options.includes(current)) return options;
  return [current, ...options];
}
